'use client';

import Link from 'next/link';
import styles from './Breadcrumbs.module.css';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  isCurrent?: boolean;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <div className={styles.breadcrumbs}>
      {items.map((item, index) => (
        <div key={index} className={styles.breadcrumbItem}>
          {item.href && !item.isCurrent ? (
            <Link href={item.href} className={styles.link}>
              {item.label}
            </Link>
          ) : (
            <span
              className={item.isCurrent ? styles.currentPage : styles.separator}
            >
              {item.isCurrent ? item.label : '›'}
            </span>
          )}
          {index < items.length - 1 && !item.isCurrent && (
            <span className={styles.separator}>›</span>
          )}
        </div>
      ))}
    </div>
  );
}
